import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48debca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-file-wrap" }

import { ActionSheet } from 'vant'
import { showNormalToast } from '@/utils/tools'
import {
  nextTick,
  watch,
  withDefaults,
  computed,
} from 'vue'
import { UploadEnums } from '@/enums/upload'
import { useUploadList } from '@/hooks/useUpload'
import { UploadFileDataItem } from '@/types/public'
import UploadFile from './UploadFile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFileGroup',
  props: {
    fileList: null,
    onlyCheck: { type: Boolean },
    multiple: { type: Boolean, default: true },
    useAction: { type: Boolean, default: true },
    uploadTo: null,
    fileSizeLimit: null,
    fileSizeLimitMessage: null
  },
  emits: ['change', 'init'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { fileList?: UploadFileDataItem[], onlyCheck?: boolean, multiple: boolean, useAction: boolean, uploadTo?: string, fileSizeLimit?: number, fileSizeLimitMessage?: string };




console.log('props.uploadTo,', props.uploadTo)
const {
  inputVm,
  fileList,
  inputAttrs,
  onPreview,
  onPreviewVideo,
  onFileAdd,
  onUploadChange,
  onDelete,
  onBeforeStart,
  onActionSelect,
  uploadActions,
  uploadActionShow,
  uploadHandle,
  resetHandle,
  clearFileList,
} = useUploadList({
  fileList: props.fileList || [],
  onlyCheck: props.onlyCheck,
  multiple: props.multiple,
  useAction: props.useAction,
  uploadTo: props.uploadTo,
})

watch(
  () => fileList.value,
  () => {
    emits(
      'change',
      fileList.value
        .filter((item: UploadFileDataItem) => item.status === UploadEnums.Success)
        .map((item: UploadFileDataItem) => ({
          ...item,
        }))
    )
  },
  {
    deep: true,
  }
)

function fileSizeVerify(files: File[]) {
  const hasOverLimit = files.some((file) => {
    return file.size / 1024 > props.fileSizeLimit
  })
  if (hasOverLimit) {
    // 有文件超过大小
    showNormalToast(props.fileSizeLimitMessage || '文件超过限制的大小')
    return false
  }
  return true
}
async function onFileChange(data: any) {
  const files = data?.target?.files || []
  if (props.fileSizeLimit && props.fileSizeLimit > 0 && !fileSizeVerify([...files])) {
    return
  }
  nextTick(() => {
    if (inputVm.value) {
      inputVm.value.value = ''
    }
  })
  onFileAdd([...files])
}

expose({
  resetHandle,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({
      type: "file",
      ref_key: "inputVm",
      ref: inputVm
    }, _unref(inputAttrs), {
      multiple: "",
      class: "upload-input",
      onChange: onFileChange
    }), null, 16),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), (item) => {
      return (_openBlock(), _createBlock(UploadFile, {
        fileInfo: item,
        key: item.uuid,
        onBeforeStart: _unref(onBeforeStart),
        onDelete: _unref(onDelete),
        onChange: _unref(onUploadChange),
        onPreview: _unref(onPreview),
        onPreviewVideo: _unref(onPreviewVideo),
        onlyCheck: props.onlyCheck,
        uploadHandle: _unref(uploadHandle)
      }, null, 8, ["fileInfo", "onBeforeStart", "onDelete", "onChange", "onPreview", "onPreviewVideo", "onlyCheck", "uploadHandle"]))
    }), 128)),
    _createVNode(_unref(ActionSheet), {
      show: _unref(uploadActionShow),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(uploadActionShow) ? (uploadActionShow).value = $event : null)),
      actions: _unref(uploadActions),
      onSelect: _unref(onActionSelect),
      teleport: "body"
    }, null, 8, ["show", "actions", "onSelect"])
  ]))
}
}

})